import { styled } from '@mui/material/styles';
import { Box, Stack, AppBar, Toolbar, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import navConfig from '../navbar/NavConfig';
import AlertsPopover from './AlertsPopover';
import LanguagePopover from '../../../components/LanguagePopover';
import NotificationsPopover from '../../../components/NotificationsPopover';
import AccountPopover from './AccountPopover';

// ----------------------------------------------------------------------

const RootStyle = styled(AppBar)(({ theme }) => ({
  backgroundColor: '#F5F5F5',
  boxShadow: 'none',
  height: 110,
  zIndex: theme.zIndex.appBar + 1,
  paddingRight: 24,
  paddingLeft: 24,
  paddingTop: 18,
  paddingBottom: 18,
  width: `calc(100% - 190px)`,
  margin: 0,

  [theme.breakpoints.up('xl')]: {
    width: `calc(100% - 220px)`,
  },
}));

// ----------------------------------------------------------------------

export default function DashboardHeader() {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  let pageName = '';
  navConfig.forEach((nav) => {
    const found = nav.items.find((i) => pathname.indexOf(i.path) !== -1);
    if (found) pageName = found?.title || '';
  });

  return (
    <RootStyle>
      <Toolbar
        sx={{
          minHeight: '100% !important',
          px: 3,
          borderRadius: '23px',
          bgcolor: '#fff',
        }}
      >
        <Typography variant="h5" color="#000" sx={{ fontWeight: 500, mt: 0.3 }} lineHeight={1}>
          {pageName ? t(pageName) : ''}
        </Typography>
        <Box sx={{ flexGrow: 1 }} />

        <Stack direction="row" alignItems="center" spacing={{ xs: 0.5, sm: 1.5 }}>
          <LanguagePopover />
          <AlertsPopover />
          <NotificationsPopover />
          <AccountPopover/>
        </Stack>
      </Toolbar>
    </RootStyle>
  );
}
